import React, { useState, useEffect, useRef  } from 'react';
import { Button } from 'react-bootstrap';
import { FaAngleDown } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

const CategoriesHeader = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { pathname } = useLocation();
    const dropdownRef = useRef();

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (window !== undefined) {
            window.addEventListener('scroll', function () {
                setIsOpen(false);
            });
        }

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
            document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])

    useEffect(() => {
        setIsOpen(false);
    }, [pathname])

    const renderSubCategory = (data) => {
        return (
            <ul className="subcategory">
                <h4 className="has-after fw-bold p-3 pb-2">{data.name}</h4>
                {
                data.children_categories.map((x, k) => (
                        <li className="dropend" key={k}>
                            <Button as={Link} to={"/categories/" + data.slug + '/' + x.slug} >{x.name}</Button>
                        </li>
                    ))
                }
            </ul> 
        )
    }

    return (
        <>
            <Button className="btn btn-lg text-white lh-lg btn-category-navbar" onClick={toggleDropdown}>
                All Products <FaAngleDown />
            </Button>

            {isOpen && (
                <ul className="dropdown-category-navbar" ref={dropdownRef}>
                    <li className="dropend">
                        <Button as={Link} to="/brands">Search by Brand</Button>
                    </li>
                    <hr />
                    <div className="dropdown-list-category">
                        {
                            props.data.map((d, i) => (
                                <li className="dropend category-item" key={i}>
                                    <Button as={Link} to={"/categories/" + d.slug}>{d.name}</Button>
                                    {d.children_categories.length > 0 && renderSubCategory(d) }
                                </li>
                            ))
                        }
                    </div>
                </ul>
            )}
        </>
    )
}

export default CategoriesHeader
